import { useQuery } from '@tanstack/react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type { SearchData } from '../common';
import { getUseSearchPartsQueryKey, UseSearchPartsQueryKey } from './keys';
import type { UseSearchPartsParams } from './types';

export const useSearchParts: QueryFunction<
  SearchData,
  [body: UseSearchPartsParams],
  UseSearchPartsQueryKey
> = (body, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useQuery({
    ...queryOptions,
    queryKey: getUseSearchPartsQueryKey(body),
    queryFn: ({ signal }) =>
      request('/search/parts', {
        init: {
          signal,
          method: 'POST',
          body: { ...body },
        },
      }),
  });
};
